var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNobelParkFloorplan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "-20 -20 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "scale(1,-1)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#e9faf2",
    stroke: "#555555",
    strokeWidth: 0.1,
    opacity: 0.8,
    d: "M -6.185507717729729,14.037270210426103 L 5.674492328591471,14.037270210426103 L 5.674492328591471,-14.152729870189296 L -6.185507717729729,-14.152729870189296 L -6.185507717729729,14.037270210426103 z M -5.7830564577680095,7.877270184051993 L -5.7830564577680095,-1.2518119128893266 L -3.875507917909979,-1.2518119128893266 L -3.875507917909979,6.507270184051993 L -3.475507917909979,6.507270184051993 L -3.475507917909979,7.877270184051993 L -5.7830564577680095,7.877270184051993 z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#e9faf2",
    stroke: "#555555",
    strokeWidth: 0.1,
    opacity: 0.6,
    d: "M 0.24649238354107397,-11.9007297486843 L 0.24649238354107397,-11.900729748684299 L 3.32449235636229,-11.900729748684299 L 3.32449235636229,-10.362729720108701 L 2.3244922842594797,-10.362729720108701 L 2.3244922842594797,-10.36272972010872 L 2.00049228425948,-10.36272972010872 L 2.00049228425948,-7.1627297112897 L 5.174492184748342,-7.1627297112897 L 5.174492180064386,-6.862729693001789 L 5.774492180064385,-6.862729683633879 L 5.774492190525218,-7.532729686286285 L 5.174492190525219,-7.532729695654195 L 5.174492189807013,-7.4867297112896996 L 2.3244922842594797,-7.4867297112896996 L 2.3244922842594797,-10.0387297201087 L 5.17449222846526,-10.0387297201087 L 5.17449222846526,-9.862729691189621 L 5.77449222846526,-9.862729691189621 L 5.77449222846526,-14.24272969118962 L 5.17449222846526,-14.24272969118962 L 5.17449222846526,-14.242729691189599 L -0.9455076164824904,-14.242729691189599 L -0.9455076164824904,-13.6427296911896 L 0.12249238354107397,-13.6427296911896 L 0.12249238354107397,-11.9007297486843 L 0.24649238354107397,-11.9007297486843 z M 3.64849235636229,-10.362729720108701 L 3.64849235636229,-11.900729748684299 L 5.17449222846526,-11.900729748684299 L 5.17449222846526,-10.362729720108701 L 3.64849235636229,-10.362729720108701 z M 5.17449222846526,-12.224729748684299 L 0.446492383541074,-12.224729748684299 L 0.446492383541074,-13.6427296911896 L 5.17449222846526,-13.6427296911896 L 5.17449222846526,-12.224729748684299 z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#e9faf2",
    stroke: "#555555",
    strokeWidth: 0.1,
    opacity: 0.6,
    d: "M 5.174492180064417,11.137270306998253 L 5.774492180064415,11.137270316366163 L 5.774492190525248,10.467270313713755 L 5.174492190525249,10.467270304345845 L 5.174492180064417,11.137270306998253 z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#e9faf2",
    stroke: "#555555",
    strokeWidth: 0.1,
    opacity: 0.6,
    d: "M 5.174492190525238,4.4672703043458055 L 5.174492180064406,5.137270306998212 L 5.774492180064405,5.137270316366122 L 5.774492190525238,4.4672703137137155 L 5.174492190525238,4.4672703043458055 z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#e9faf2",
    stroke: "#555555",
    strokeWidth: 0.1,
    opacity: 0.6,
    d: "M 5.774492180064405,2.1372703163661213 L 5.774492190525238,1.4672703137137144 L 5.174492190525238,1.4672703043458042 L 5.174492180064406,2.1372703069982117 L 5.774492180064405,2.1372703163661213 z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#e9faf2",
    stroke: "#555555",
    strokeWidth: 0.1,
    opacity: 0.6,
    d: "M 5.774492190525238,7.467270313713715 L 5.174492190525238,7.467270304345805 L 5.174492180064406,8.13727030699821 L 5.774492180064405,8.13727031636612 L 5.774492190525238,7.467270313713715 z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#e9faf2",
    stroke: "#555555",
    strokeWidth: 0.1,
    opacity: 0.6,
    d: "M 5.174492180064396,-3.8827296930017883 L 5.774492180064395,-3.8827296836338783 L 5.774492190525228,-4.552729686286285 L 5.174492190525228,-4.552729695654195 L 5.174492180064396,-3.8827296930017883 z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#e9faf2",
    stroke: "#555555",
    strokeWidth: 0.1,
    opacity: 0.6,
    d: "M 5.774492180064395,-0.8627296836338776 L 5.774492190525228,-1.5327296862862845 L 5.174492190525228,-1.5327296956541947 L 5.174492180064396,-0.8627296930017876 L 5.774492180064395,-0.8627296836338776 z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#e9faf2",
    stroke: "#555555",
    strokeWidth: 0.1,
    opacity: 0.6,
    d: "M -1.12550804374162,13.522270136186501 L -1.12550804374162,14.122270136186499 L 5.774491956258379,14.122270136186499 L 5.774491956258379,13.46727030879828 L 5.17449195625838,13.46727030879828 L 5.17449195625838,13.522270136186501 L -1.12550804374162,13.522270136186501 z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#e9faf2",
    stroke: "#555555",
    strokeWidth: 0.1,
    opacity: 0.6,
    d: "M -5.683056457768,14.122270136186499 L -2.61550804379741,14.122270136186499 L -2.61550804379741,8.001270184051975 L -2.6155080437974187,7.77727018405199 L -5.683056457768,7.77727018405199 L -5.683056457768,7.4672701361865155 L -6.283056457768,7.4672701361865155 L -6.283056457768,14.122270136186524 L -5.683056457768,14.122270136186524 L -5.683056457768,14.122270136186499 z M -5.683056457768,8.10127018405199 L -2.9395080437974097,8.10127018405199 L -2.9395080437974097,13.522270136186501 L -5.683056457768,13.522270136186501 L -5.683056457768,8.10127018405199 z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#e9faf2",
    stroke: "#555555",
    strokeWidth: 0.1,
    opacity: 0.6,
    d: "M -6.28305645776803,-0.8827298684589092 L -5.68305645776803,-0.8827298684589092 L -5.68305645776803,-7.17872986845891 L -4.89950771764209,-7.17872986845891 L -4.89950771764209,-7.178729868458905 L -4.57550771764209,-7.178729868458905 L -4.57550771764209,-10.298326801617316 L -4.89950771764209,-10.298326801617316 L -4.89950771764209,-10.2983268016173 L -5.68305645776803,-10.2983268016173 L -5.68305645776803,-13.642729691189599 L -4.895507616457812,-13.642729691189599 L -4.895507616457812,-14.242729691189599 L -6.283056457768032,-14.242729691189599 L -6.283056457768032,-13.742729691189599 L -6.28305645776803,-7.28272986845892 L -6.28305645776803,-0.8827298684589092 z M -4.89950771764209,-7.50272986845891 L -5.68305645776803,-7.50272986845891 L -5.68305645776803,-9.9743268016173 L -4.89950771764209,-9.9743268016173 L -4.89950771764209,-7.50272986845891 z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#e9faf2",
    stroke: "#555555",
    strokeWidth: 0.1,
    opacity: 0.6,
    d: "M -6.283056457768,4.46727013618513 L -6.283056457768,5.137270136375595 L -5.683056457768,5.137270136375595 L -5.683056457768,4.46727013618513 L -6.283056457768,4.46727013618513 z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#e9faf2",
    stroke: "#555555",
    strokeWidth: 0.1,
    opacity: 0.6,
    d: "M -6.2830564577680095,1.4672701337515903 L -6.2830564577680095,2.1372701363741955 L -5.68305645776801,2.1372701363741955 L -5.68305645776801,1.4672701337515903 L -6.2830564577680095,1.4672701337515903 z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNobelParkFloorplan);
export default __webpack_public_path__ + "static/media/nobel_park_floorplan_.edbff675140358eab3b5933b5dae79c0.svg";
export { ForwardRef as ReactComponent };